import { Component, Input } from '@angular/core';
import { TaskService } from '../../../app/services/tasks/task.service';

@Component({
  selector: 'fury-handling-days-indicator',
  templateUrl: './handling-days-indicator.component.html',
  styleUrls: ['./handling-days-indicator.component.scss'],
})
export class HandlingDaysIndicatorComponent {
  @Input() data: {
    handled_days: number;
    handling_days: number;
  };

  constructor(public taskService: TaskService) {
  }
}
